import angular from 'angular';

class MetricsDumpCtrl {
    $onInit() {
        var vm = this;

        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(vm.resolve.threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll =
            vm.threadDumpRunnable + vm.threadDumpWaiting + vm.threadDumpTimedWaiting + vm.threadDumpBlocked;
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }

    getLabelClass(threadState) {
        if (threadState === 'RUNNABLE') {
            return 'label-success';
        } else if (threadState === 'WAITING') {
            return 'label-info';
        } else if (threadState === 'TIMED_WAITING') {
            return 'label-warning';
        } else if (threadState === 'BLOCKED') {
            return 'label-danger';
        }
    }
}

angular.module('app.admin.metrics').component('metricsDump', {
    templateUrl: require('./metrics.dump.modal.html'),
    controller: MetricsDumpCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<'
    }
});
